// eslint-disable-next-line no-shadow
export enum MediaTypeView {
	IMAGE = 'Image',
	VIDEO = 'Video',
}
